import { all, call, put, select, takeLatest } from 'redux-saga/effects';

import * as errorHandlerActions from '@/components/errorHandler/Actions';
import * as autonomyActions from '@/pages/autonomy/Actions';
import * as learningPathActions from '@/pages/learningPath/Actions';
import { autonomyActionTypes } from '@/pages/autonomy/Constants';
import { FRONTEND_ROUTES, ROUTES_API } from '@/services/Constants';
import { isLearningPath } from '@/shared/Helpers';
import { getUserPlayMode } from '@/pages/learningPath/Selectors';
import { Step } from '@/pages/learningPath/types';
import { processRequest } from '@/services/Api';
import { historyPush } from '@/services/History';

// Root saga
export default function* (): Generator {
	yield all([
		takeLatest(autonomyActionTypes.GET_AUTONOMY_STEPS_REQUEST, handleGetAutonomyStepsRequest),
		takeLatest(autonomyActionTypes.SAVE_STEPS_POSITION_REQUEST, handleSaveStepsPositionRequest),
		takeLatest(autonomyActionTypes.SAVE_ENGAGE_TIME_REQUEST, handleSaveEngageTimeRequest),
	]);
}

// Saga to handle GET_AUTONOMY_STEPS_REQUEST
export function* handleGetAutonomyStepsRequest(): Generator {
	let userPlayMode = null;

	try {
		userPlayMode = yield select(getUserPlayMode);

		const { data } = yield call(processRequest, ROUTES_API.USER_LEARNING_PATHS);

		if (data.success === false && isLearningPath(userPlayMode)) {
			yield call(historyPush, FRONTEND_ROUTES.GOAL_SETTINGS);
			return;
		}

		yield put(autonomyActions.getAutonomyStepsSuccess(data.learning_path));
	} catch (e: any) {
		yield put(errorHandlerActions.handleError(e));
		yield put(autonomyActions.getAutonomyStepsError());
	}
}

// Saga to handle SAVE_STEPS_POSITION_REQUEST
export function* handleSaveStepsPositionRequest({ payload }: any): Generator {
	const { autonomySteps, orderedSteps, steps, skipped } = payload || {};
	try {
		const body = {
			user_learning_path_section_ids: orderedSteps
				.filter((step: Step) => !!step.id && !!step.user_learning_path_id)
				.map((step: Step) => step.id),
			original_user_learning_path_section_ids: steps
				.filter((step: Step) => !!step.id && !!step.user_learning_path_id)
				.map((step: Step) => step.id),
			not_chosen_user_learning_path_section_ids: autonomySteps.map((step: Step) => step.id),
			skipped,
		};
		yield call(processRequest, ROUTES_API.USER_LEARNING_PATH_SECTION_POSITIONS, 'POST', body);
		yield put(autonomyActions.saveStepsPositionSuccess());
		yield put(learningPathActions.setAutonomyMode(false));
		yield put(learningPathActions.getLearningPathRequest());
	} catch (e: any) {
		yield put(errorHandlerActions.handleError(e));
		yield put(autonomyActions.saveStepsPositionError());
	}
}

// Saga to handle SAVE_ENGAGE_TIME_REQUEST
export function* handleSaveEngageTimeRequest({ payload }: any): Generator {
	const { engageTime } = payload || {};
	try {
		const body = {
			time_in_seconds: engageTime,
			experiment_name: 'experiment_2025_Q2_autonomy',
		};
		yield call(processRequest, ROUTES_API.USERS_EXPERIMENT_TIMES, 'POST', body);
		yield put(autonomyActions.saveEngageTimeSuccess());
	} catch (e: any) {
		yield put(errorHandlerActions.handleError(e));
		yield put(autonomyActions.saveEngageTimeError());
	}
}
